export const colors = {
    black: '#000000',
    error: '#f5222d',
    light: '#7e7e7e',
    primary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14'
};
